// Hand-drawn sparkle icon matching the design
export const SparkleIcon = ({ className = "w-6 h-6" }) => {
    return (
        <svg 
            viewBox="0 0 24 32" 
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
        >
            {/* Top sparkle */}
            <path d="M12 2 L12 8" />
            <path d="M9 5 L15 5" />
            {/* Bottom sparkle */}
            <path d="M12 24 L12 30" />
            <path d="M9 27 L15 27" />
        </svg>
    );
};

// Hand-drawn arrow pointing down
export const ArrowDown = ({ className = "w-8 h-12" }) => {
    return (
        <svg 
            viewBox="0 0 40 60" 
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        >
            <path d="M20 5 Q 22 25, 20 45" />
            <path d="M12 38 Q 18 48, 20 50 Q 22 48, 28 38" />
        </svg>
    );
};

// Hand-drawn arrow for footer (curved left arrow)
export const ArrowLeft = ({ className = "w-12 h-6" }) => {
    return (
        <svg 
            viewBox="0 0 60 30" 
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        >
            <path d="M55 15 Q 30 5, 10 15" />
            <path d="M18 8 Q 10 14, 10 15 Q 10 16, 16 22" />
        </svg>
    );
};
